import { factory, primaryKey } from '@mswjs/data'

import Env from 'config/Env'
import initialMockedDb from '@/test/msw/fixtures/db.initial.data.json'

const models = {
  posts: {
    id: primaryKey(String),
    title: String,
    body: String,
  },
}

export const db = factory(models)

// export type Model = keyof typeof db

export const restoreDb = () => {
  const dbFromLocalStorage = window.localStorage.getItem('demo-app-db')

  if (dbFromLocalStorage) {
    return Object.assign(JSON.parse(dbFromLocalStorage))
  }

  return initialMockedDb
}

export const clearDb = () => {
  window.localStorage.clear()
}

export const persistDb = model => {
  if (Env.isTest()) return
  const data = restoreDb()
  data[model] = db[model].getAll()
  window.localStorage.setItem('demo-app-db', JSON.stringify(data))
}

export const initializeDb = () => {
  const database = restoreDb()

  Object.entries(db).forEach(([key, model]) => {
    const dataEntries = database[key]
    if (dataEntries) {
      dataEntries?.forEach(entry => {
        model.create(entry)
      })
    }
  })
}

initializeDb()
